module.exports = "/assets/data/9314a61d7c04ef8c49331eed953d1adb-CA2.data.json";